<div class="g_modal-dialog g_backdrop">
    <div class="g_dialog-container info-modal-window"
         (click)="$event.stopPropagation()"
         (mousedown)="$event.stopPropagation()">


        <div class="g_dialog-header">
            <div>Portal gesperrt bis alle Vereinbarungen akzeptiert wurden</div>
        </div>


        <div class="g_dialog-content">
            Es gibt eine oder mehrere neue Vereinbarungen, welche zur Nutzung des Portals zuerst bestätigt werden müssen. <br>
            Bitte kontaktieren Sie Ihren Hauptkontakt und bitten Sie diesen die Bedingungen zu prüfen und anschließend zu bestätigen. Im Anschluss können Sie das Portal wieder wie gewohnt weiter nutzen.
        </div>


    </div>

</div>
